module.exports = __webpack_public_path__ + "img/icone-harvest.a68b9791.svg";